import { useCallback } from 'react';
import { httpClient, ROOT_URL } from '../../App';
import { message } from 'antd';
import { getErrorMessage } from '../../api/error';

export const useDeleteBank = () => {
  const deleteBank = useCallback(async (id: number) => {
    try {
      await httpClient.delete(`${ROOT_URL}/api/v1/banks/${id}`);
    } catch (error) {
      message.error(getErrorMessage(error));
    }
  }, []);

  return { deleteBank };
};
